function loading(t,i){themes={light:["255,255,255","58,152,217"],dark:["31,31,31","195,195,195"],mid:["63,63,63","246,246,256"]},"undefined"!=typeof i&&themes.hasOwnProperty(i)||(i="light"),this.theme=themes[i],this.c=t,this.div=!1,this.interval=!1}loading.prototype={init:function(){var t=$("<canvas></canvas>").get(0);"undefined"!=typeof G_vmlCanvasManager?(t.width=64,t.height=64,this.div=$('<div class="loading"></div>').append(t).css("visibility","visible").appendTo(this.c),G_vmlCanvasManager.initElement(t),this.ctx=t.getContext("2d")):t.getContext&&(t.width=64,t.height=64,this.ctx=t.getContext("2d"),this.div=$('<div class="loading"></div>').append(t).css("visibility","visible").appendTo(this.c))},show:function(){if(this.div||this.init(),this.div){this.interval&&clearInterval(this.interval),this.start=Date.now(),this.tick(),this.div.show();var t=this;this.interval=setInterval(function(){t.tick()},100)}},hide:function(){this.interval&&(clearInterval(this.interval),this.interval=!1,this.div.hide())},tick:function(){var t=Math.floor((Date.now()-this.start)%1600/100)+4;this.ctx.clearRect(0,0,64,64);var i;for(this.ctx.save(),this.ctx.translate(32,32),i=0;12>i;i++)this.ctx.save(),this.ctx.rotate(Math.PI/8*(t+i)%16),this.ctx.fillStyle="rgba("+this.theme[0]+","+(.125+i/32)+")",this.ctx.fillRect(-3,-32,6,20),this.ctx.fillStyle="rgba("+this.theme[1]+","+(.25+i/16)+")",this.ctx.fillRect(-1,-30,2,16),this.ctx.restore();this.ctx.restore()}};


/*
 * @preserve
 * Copyright 2015-2017 All Rights Reserved
 * info@netbreeze.com.au
 */
function estimator(data) {

	var obj = this;

	this.data = data;
	this.div = $('#estimator');
	this.totalDiv = $('.sk_cta--cubic-total');

	$('div.catlab', this.div).each(function() {
		this._div = $(this).next();
	}).bind('click', function() {
		obj.toggle(this);
		$(this).toggleClass('is-active');
	});

	this.t = new Array();

	$('input.ct').each(function() {

		var out = this.id.substr(1);
		var outname = 't' + out;

		obj.t.push(this.form[outname]);

		if (isNaN(this.value) || !this.value || this.value == '0') {
			this.value = '';
			this.form[outname].value = '';
		} else {
			this.form[outname].value = Math.round(Number(this.value) * obj.data[out]) / 100;
		}

	}).bind('change', function() {

		var out = this.id.substr(1);
		var outname = 't' + out;

		if (isNaN(this.value) || !this.value || this.value == '0') {
			this.value = '';
			this.form[outname].value = '';
		} else {
			this.form[outname].value = Math.round(Number(this.value) * obj.data[out]) / 100;
		}

		obj.updatetotal();

	});

	this.updatetotal();
}

estimator.prototype = {
	updatetotal: function() {
		var total = 0;

		$.each(this.t, function() {
			total += Number(this.value);
		});

		var total = Math.round(100 * total) / 100;

		if (total > 0) {
			this.totalDiv.addClass('is-visible');
		} else {
			this.totalDiv.removeClass('is-visible');
		}

		this.totalDiv.find('h2').html('You need approximately ' + total + 'M<sup>3</sup>');
	},

	toggle: function(ele) {
		if ($(ele).hasClass('catlabx')) {
			this.hide(ele);
		} else {
			this.show(ele);
		}
	},

	show: function(ele) {
		$(ele).toggleClass('catlabx', true);
		ele._div.stop(true, true).addClass('is-visible');
	},

	hide: function(ele) {
		$(ele).toggleClass('catlabx', false);
		ele._div.stop(true, true).removeClass('is-visible');
	}
};





/*
 * @preserve
 * This file is copyright (C) Daniel James 2014, all rights reserved.
 * PH: +61 1800 888 981 E: info@netbreeze.com.au
 */

// ##### New Style Room Estimator
function vi(detail) {
	this.detail = detail;
	var canvas = $('canvas#room').get(0);
	if (typeof canvas.getContext=='undefined') {
		if (typeof G_vmlCanvasManager != 'undefined') {
			G_vmlCanvasManager.initElement(canvas);
			G_vmlCanvasManager.initElement($('canvas#overlay').get(0));
		}
	}
	if (typeof canvas.getContext!='undefined') {
		this.init();
	}
	this.scrollsafe = true;
	$(window).on("scroll", function() {
		this.scrollsafe=false;
	}.bind(this));
}

vi.prototype={
	init: function() {

		var obj = this;

		this.div = $('div#vi');
		this.resultsContainer = $('.sk_space-estimator__result');

		this.viewdiv = $('<div class="view"></div>').append(

		this.view = $('<button class="btn btn-primary btn-wrap">Calculate Estimated Space Required</button>')
			.on({
				mouseenter:function() {
					$(this).addClass('hover');
				},
				mouseleave:function() {
					$(this).removeClass('hover');
				},
				click:function() {
					obj.showroom();
					$('.sk_space-estimator__result-disclaimer').addClass('is-visible');
				}
			}).css('opacity', 0).height(0).css('display', 'block')
		).prependTo(this.resultsContainer);

		this.vpack = new vipack(this, true);
		this.hpack = new vipack(this, false);
		this.buttons = new vibuttons(this);
		this.room = new viroom(this);
		this.loading = new loading(this.room.div);
		this.label = new vilabel(this);
		this.cantfit = $('#cantfit');
		this.cantfit._height=0;
	},

	showview: function() {

		this.view.stop(true,false).css({
			opacity: 1
		});

		this.cantfit.stop(true).hide();
	},

	hideview: function() {
		this.view.stop(true,false).css({
			opacity: 0
		});
	},

	scroll: function() {
	},

	fititems: function() {
		// Room dimensions precalculated to speed everything up
			//[294,60,160,155,240,433,240,294,380, 12, 86], // This is a more zoomed in locker
			//[294,110,110,199,165,389,165,294,330, 12, 86], // Less zoomed in locker
			//[294,10,280,173,350,415,350,294,430, 20, 239], // this is a more zoomed in wardrobe
		var rooms=[
			//[294,60,160,155,240,433,240,294,380, 12, 86], // Locker No longer displayed
			[294,30,254,185,317,403,317,294,410, 20, 239], // Wardrobe
			[348,10,239,137,361,451,298,240,430, 13, 239], // Quarter Garage
			[296,10,210,112,316,476,314,292,430, 14, 239], // Half Garage
			[255,10,186,91,281,497,325,333,430, 15, 239], // Three Quarter Garage
			[196,10,152,62,230,526,343,392,430, 16, 239], // Single Garage
			[175,10,140,51,211,537,349,413,430, 17, 239] // Double Garage
		];

		// Items are packed from most space consuming to least space consuming.
		// They will be packed in horizontal and vertical layouts and then the most
		// compact layout will be displayed
		var packorder = [
			19, // Ensemble
			20, // Bed Frame
			21, // Buffet
			10, // Dining Table
			18, // Desk
			16, // Fridge
			15, // 3 Seater Lounge
			14, // 2 Seater Lounge
			12, // Tallboy
			11, // Bookshelf
			9, // Coffee Table
			8, // Small Table
			13, // 1 Seater Lounge
			6, // Bike
			5, // Television
			17, // Desk Chair
			4, // Washing Machine
			7, // Bedside Table
			3, // Dining Chair
			1, // Large Box
			2, // Packing Bag
			0 // Small Box
		];

		var ct = packorder.length;

		var room=0,vfit=false, hfit=false, item, x, cbm;

		while(room < rooms.length && (!vfit && !hfit)) {
			vfit = true; hfit = true; cbm=0;

			this.vpack.setroom(room, rooms[room]);
			this.hpack.setroom(room, rooms[room]);

			for(item = 0; (item < ct) && (vfit || hfit); item ++) {
				for(x=0; (x < this.buttons.list[packorder[item]].countval) && (vfit || hfit); x++) {
					vfit = vfit && this.vpack.add(this.buttons.list[packorder[item]]);
					hfit = hfit && this.hpack.add(this.buttons.list[packorder[item]]);
					cbm+=this.buttons.list[packorder[item]].cbm;
				}
			}

			room++;
		}

		this.loading.hide();

		if (vfit || hfit) { // Usually the most used space packs are a little neater...
			pack = vfit && hfit?
					(this.vpack.used < this.hpack.used?this.vpack:this.hpack):
					(vfit?this.vpack:this.hpack);
			this.room.select(rooms[room - 1]);
			pack.load();
			pack.draw();
			this.room.show();
			var tst,sqm = Math.round(cbm * 10 * 1.3 / 2.7)/10;
			var listroom=false;
			for (tst in this.detail) {
				if (this.detail[tst][1] >= sqm) {
					break;
				}
				listroom = tst
			}
			if (listroom===false) {
				listroom=tst;
			}
			//pack.show(this.detail['r'+rooms[room - 1][9]][0], sqm);
			$(".sk_space-estimator__result h5").text(this.detail[listroom][0]);
            $(".sk_space-estimator__result .des").text('You need approximately a '+this.detail[listroom][0]+' sized space');
            var _name = this.detail[listroom][0].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            $(".sk_space-estimator__result .btn-view-details").attr("href", "/collections/our-unit-types-"+ _name);
						var toolItemsAdded = $('.sk_space-estimator__total').text();
						$(".sk_space-estimator__result .btn-view-details").attr("data-name", this.detail[listroom][0]).attr("data-item", toolItemsAdded);			
			pack.show(this.detail[listroom][0], sqm);
			//GA4 Space Estimator Tool
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'space_estimator_tool',
				data: {
					'toolStep': 'calculate_space',
					'formProduct': this.detail[listroom][0],
					'toolItemsAdded': toolItemsAdded					
				}
			});
		} else {
			this.room.hide();
			this.cantfit.show();
		}
	},
	showroom: function() {
		if (!this.viewdiv.hasClass('disabled')) {

			this.room.clear();
			this.loading.show();
			this.buttons.loadimages();

			var offset = this.viewdiv.offset();

			this.viewdiv.addClass('disabled');

			this.view.stop(true).css({
				opacity: 0
			});

			offset = offset.top;

			var windowheight = $(window).height();

			if (windowheight > 440) {
				offset-= (windowheight - 440) / 2;
			}

			if (offset > $(document).height() - windowheight) {
				offset = $(document).height() - windowheight;
			}
		}
	},
	hideroom: function() {
		if (this.viewdiv.hasClass('disabled')) {
			this.vpack.hide();
			this.hpack.hide();
			this.room.hide();
			this.label.hide();
			this.scrollsafe = false;
			this.viewdiv.removeClass('disabled');
			this.showview();
			$(".sk_space-estimator__result").removeClass("on");
		}
	}
}

function vilabel(app) {
	this.div = $('.sk_cta--vi_result');
}

vilabel.prototype = {
	load: function(detail, size) {
		var text = 'You need approximately a <span style="white-space:nowrap">'+detail+'</span> sized space';

		if (window.surl) {
			$('#reslink').attr('href', '/'+window.surl+'/reserve-online?m2='+escape(size));
		}

		// Set the text
		//text.= ' (';
		//if (size <= 1) size = text + '1m<sup>2</sup>';
		//else size = text + size + 'm<sup>2</sup>';
		//size+=')';

		// Show the CTA
		this.div.removeClass('is-hidden');
		this.div.find('h2').html(text);
	},

	show: function() {
		this.div.removeClass('is-hidden');
	},

	hide: function() {
		this.div.addClass('is-hidden');
	}
}

function vipack(app, orientation) {
	this.room = false;
	this.app = app;
	this.items = [];
	this.previous = false;
	this.div = false;
	this.vert = orientation === true;
}

vipack.prototype = {
	init: function() {

		if (this.div !== false) {
			return;
		}

		this.div = $('<div class="pack"></div>').appendTo(this.app.room.div);
	},

	setroom: function(room, dim) {
		var scale = 0.75; // How much should the items globally be scaled by?
		this.init();
		this.hide();
		if(this.room !== room) {
			this.room = room;
			this.mul = dim[2] / dim[10] * scale;
			this.vmax = dim[2];
			this.w = dim[0] - dim[3];
			this.d = dim[5] - dim[0];
		}
		this.items = [];
		this.previous = false;
		this.used = 0;
		//console.log(this.w);
		//console.log(this.d);
	},

	success: function(item, d) {
		this.items.push(item);
		this.previous = item;
		if (d > this.used) {
			this.used = d;
		}
	},

	// Add an item to the room. Return false if the item doesn't fit
	add: function(item) {
		//console.log('requested to add '+item.name);
		if (this.previous !== false && this.previous.another(item)) {
			return true;
		}

		if (item.minroom > this.room) {
			//console.log("Too tall for room");
			return false;
		}

		var d, newitem = new vipackitem(this, item);

		if (d=newitem.search(this.vert)) {
			//console.log("Successfully added in default oritentation");
			this.success(newitem, d);
			return true;
		}

		if (d=newitem.search(!this.vert)) {
			//console.log("Successfully added in alternate oritentation");
			this.success(newitem, d);
			return true;
		}
		//console.log("Could not add");
		return false;
	},

	load: function() {
		var x;
		for (x = 0; x < this.items.length; x++) {
			this.items[x].load();
		}
	},

	draw: function() {
		var x,y,ct=this.items.length;

		this.items.sort(function(a,b) {
			return a.od - b.od;
			//return (a.od+a.d) - (b.od+b.d);
		});

		testwflip: for (x = 0; x<ct - 1; x++) {
			for (y = x + 1; y < ct; y++) {
				if (this.items[x].ow + this.items[x].w >= this.items[y].ow &&
						this.items[y].ow + this.items[y].w >= this.items[x].ow &&
						this.items[y].od < this.items[x].od) {
					//this.items[y].highlight = true;
					//console.log('possible flip');
					var tmp = this.items.splice(y,1); // clip and insert
					this.items.splice(x,0,tmp[0]);
					x--;
					continue testwflip;
				}
			}
		}

		testdflip: for (x = 0; x<ct - 1; x++) {
			for (y = x + 1; y < ct; y++) {
				if (this.items[x].od + this.items[x].d >= this.items[y].od &&
						this.items[y].od + this.items[y].d >= this.items[x].od &&
						this.items[y].ow < this.items[x].ow) {
					//this.items[y].highlight = true;
					//console.log('possible flip');
					var tmp = this.items.splice(y,1); // clip and insert
					this.items.splice(x,0,tmp[0]);
					x--;
					flag = true;
					continue testdflip;
				}
			}
		}

		for (x = 0; x < ct; x++) {
			this.items[x].draw();
		}
	},
	show: function(detail, size) {
		var obj=this, x = 0;
		this.app.scrollsafe = true;
		if (this.showi) {
			clearInterval(this.showi);
		}
		obj.app.label.load(detail, size);

		this.showi = setInterval(function() {
			obj.items[x].show();
			x++;
			if (x >= obj.items.length) {
				clearInterval(obj.showi);
				obj.showi=false;
				obj.app.label.show();
				setTimeout(function() {
					$(".sk_space-estimator__result").addClass("on");
				}, 1000);
			}
		}, 200);
	},
	hide: function() {
		if (this.showi) {
			clearInterval(this.showi);
			this.showi=false;
		}
		for (x = 0; x < this.items.length; x++) {
			this.items[x].hide();
		}
	},
	// Search for space and return the origin or false
	search: function(w,d) {
		var searchw, searchd, maxw, maxd, item, maxi, ret;

		maxw = this.w - w; maxd = this.d - d; maxi = this.items.length

		for (searchd = 0; searchd < maxd; searchd ++) {
			var mind = false;
			for (searchw = 0; searchw < maxw; searchw ++) {
				var flag = false;
				for (item = 0; item < maxi; item++) {
					if ((ret = this.items[item].check(searchw, searchd, w, d)) !== false) {
						flag = true;
						searchw = ret[0];
						if (ret[1] < mind || mind === false) {
							// step through d using the minimum d of blocking items
							mind=ret[1];
						}
					}
				}
				if (!flag) {
					return [searchw,searchd];
				}
			}
			if (mind && mind > searchd) {
				searchd = mind;
			}
		}

		return false;
	}
}

function vipackitem(pack, item) {
	this.pack = pack;
	this.item = item;
	this.canvas = false;
	this.iw = Math.round(this.item.image.src.width * this.pack.mul);
	this.ih = Math.round(this.item.image.src.height * this.pack.mul);
	this.originy = Math.round(this.item.image.originy * this.pack.mul);
	this.highlight=false;
	this.count = 1;
	if (this.item.packy !== false) {
		this.vs=Math.round((this.item.image.originy - (this.item.image.originy - this.item.packy)) * this.pack.mul);
	} else {
		this.vs = 0;
	}
}

vipackitem.prototype = {
	// Try and vertically stack
	another:function(item) {
		if (item !== this.item) {
			return false;
		}
		if (this.item.packy === false) {
			return false;
		}
		if (this.originy + this.vs * this.count <= this.pack.vmax) {
			this.count++;
			return true;
		}
		return false;
	},

	// Search
	search:function(orientation) {
		if (orientation) {
			this.w = Math.round(this.item.image.d * this.pack.mul);
			this.d = Math.round(this.item.image.w * this.pack.mul);
			this.o = true;
			this.originx = Math.round((this.item.image.src.width - this.item.image.originx) * this.pack.mul);
		} else {
			this.w = Math.round(this.item.image.w * this.pack.mul);
			this.d = Math.round(this.item.image.d * this.pack.mul);
			this.o = false;
			this.originx = Math.round(this.item.image.originx * this.pack.mul);
		}
		//console.log('looking for space '+(orientation?'flipped':'regular')+' orientation: ',this.w+','+this.d);
		var result = this.pack.search(this.w, this.d);

		if (result === false) {
			return false;
		}
		//console.log('found space at '+result[0]+','+result[1]);
		this.ow = result[0];
		this.od = result[1];
		return this.od + this.d;
	},

	// Returns this max w and max d if this item is inside the searched region
	check:function(ow, od, w, d) {
		if (this.ow < ow+w && this.ow+this.w > ow && this.od < od+d && this.od+this.d > od) {
			//console.log('item found in search area '+ow+','+od+','+w+','+d);
			return [this.ow+this.w, this.od+this.d];
		}
		return false;
	},

	load:function() {
		this.x = this.pack.app.room.ox - this.originx;
		this.x-=this.ow;
		this.x+=this.od;

		this.y = this.pack.app.room.oy - this.originy;
		this.y+=0.577350269 * (this.od + this.ow);
	},

	draw:function() {
		this.canvas = $('<canvas></canvas>');
		this.pack.div.append(this.canvas);
		if (typeof G_vmlCanvasManager!='undefined') {
			G_vmlCanvasManager.initElement(this.canvas.get(0));
		}
		this.canvas.attr('width',this.iw);
		this.canvas.attr('height',this.ih + this.vs * (this.count - 1));
		this.canvas.css({
			width:this.iw,
			height:this.ih + this.vs * (this.count - 1)
		});
		var ctx = this.canvas.get(0).getContext('2d');
		this.canvas.css({
			visibility:'hidden',
			opacity:0
		});

		var x;

		if (typeof G_vmlCanvasManager!='undefined') {
			for (x = this.count - 1; x >= 0; x --) {
				ctx.drawImage(this.o?this.item.image.ie:this.item.image.src, 0, x * this.vs, this.iw, this.ih);
			}
		} else {
			if (this.o) {
				ctx.translate(this.iw, 0);
				ctx.scale(-1,1);
			}

			for (x = this.count - 1; x >= 0; x --) {
				ctx.drawImage(this.item.image.src, 0, x * this.vs, this.iw, this.ih);
			}
		}

		this.canvas.css({
			left:this.x + 50 * this.pack.mul,
			top:this.y + 29 * this.pack.mul - this.vs * (this.count - 1)
		});
	},

	show:function() {
		this.canvas.css('visibility','visible').animate({
			opacity:this.highlight?0.6:1,
			left:this.x,
			top:this.y - this.vs * (this.count - 1)
		},600);
	},

	hide:function() {
		if (this.canvas) {
			this.canvas.remove();
		}
	}
}

function vibuttons(app) {
	this.app = app;
	this.div = $('<div class="buttons"></div>').prependTo(this.app.div);
	this.list = [];
	this.countval = 0;

	// Clear button
	this.clear = $('.sk_space-estimator__clear');
	this.clear.on('click', this.clearData.bind(this));

	this.add(new vitem(this,'Small Box', 'sb',15,32,35, 30, 36, 0, 0.08));
	this.add(new vitem(this,'Large Box', 'lb',0,40,69, 30, 69, 0, 0.15));
	this.add(new vitem(this,'Packing Bag', 'bag',0,41,61, 20, 65, 0, 0.1));

	// The 8th parameter of the following items used to be '1' as we used to show the 
	// locker as well. We no longer show this so the rooms start at wardrobe

	this.add(new vitem(this,'Dining Chair', 'dt',0,41,100, 20, 20, 0, 0.15));
	this.add(new vitem(this,'Washing Machine', 'ws',0,63,101, 10, 101, 0, 0.6));
	this.add(new vitem(this,'Television', 'tv',0,86,74, 10, false, 0, 0.4));
	this.add(new vitem(this,'Bike', 'bi',7,146,45, 10, false, 0, 0.42));
	this.add(new vitem(this,'Bedside Table', 'bt',0,43,74, 10, 74, 0, 0.15));
	this.add(new vitem(this,'Small Table', 'st',0,82,67, 10, 67, 0, 0.5));
	this.add(new vitem(this,'Coffee Table', 'ct',4,104,48, 10, 48, 0, 0.2));
	this.add(new vitem(this,'Dining Table', 'lt',2,145,79, 10, 79, 0, 1.45));
	this.add(new vitem(this,'Bookshelf', 'bs',0,75,174, 10, false, 0, 0.5));
	this.add(new vitem(this,'Tallboy', 'vd',0,80,142, 10, false, 0, 0.93));
	this.add(new vitem(this,'1 Seater Lounge', 'l1s',4,92,66, 10, 63, 0, 0.7));
	this.add(new vitem(this,'2 Seater Lounge', 'l2sv',5,64,158, 10, false, 0, 1));
	this.add(new vitem(this,'3 Seater Lounge', 'l3sv',8,62,208, 10, false, 0, 1.3));
	//this.add(new vitem(this,'2 Seater Lounge', 'l2s',5,142,65));
	this.add(new vitem(this,'Fridge', 'f',0,55,157, 10, false, 0, 2));
	this.add(new vitem(this,'Desk Chair', 'dc',0,57,78, 10, false, 0, 0.15));
	this.add(new vitem(this,'Desk', 'd',0,121,67, 10 ,67, 0, 0.85));
	//this.add(new vitem(this,'3 Seater Lounge', 'l3s',8,181,62));
	this.add(new vitem(this,'Mattress', 'ens',0,99,156, 10, false, 0, 1.25));
	this.add(new vitem(this,'Bed Frame', 'fr',0,108,165, 10, false, 0, 1.25));
	this.add(new vitem(this,'Buffet', 'b',0,154,84, 10, 84, 0, 1));

	this.load();
}


vibuttons.prototype = {

	clearData: function(e) {
		/**
		 * @function clearData
		 * Clears all button data
		 */
		if (e) e.preventDefault();

		_.each(this.app.buttons.list, function(button) {
			button.countval = 0;
			button.buttons.countval = 0;
		});

		// Reset the total
		$('.sk_space-estimator__total').text(0);
		$('.sk_space-estimator').attr('data-has-items', false);

		// Remove the button count value
		$('.buttons .button__count').each(function(e) {
			$(this).text(0).addClass('is-hidden');
		})

		// Hide the cube, show the view
		$('.view').removeClass('disabled');
		$('.room').css('display', 'none');

		$('.pack').html('');

		$('.sk_space-estimator__result-disclaimer').removeClass('is-visible');

		this.app.hideview();
		this.app.label.hide();
		this.app.scrollsafe = false;
	},

	add: function(item) {
		this.list.push(item);
	},

	load: function() {

		var x=10, y=0, ct=0, len=this.list.length, obj=this;

		// Init each button
		_.each(obj.list, function(listItem, i) {
			listItem.init(x, y);

			if ((i+1) % 8 == 0) {
				x = 10;
				y += 140;
			} else {
				x += 134;
			}

			ct++;
		});

	},

	count: function(number) {
		this.countval += number;
		this.app.hideroom();
		if (this.countval == 0) {
			this.app.hideview();
		} else if (this.countval == 1 && number == 1) {
			this.app.showview();
		}
	},

	loadimages: function() {
		var x, ct;

		this.loadcycle=true;
		this.loading=0;

		ct=this.list.length;

		if (ct == 0) {
			return;
		}

		for (x=0, ct--; x < ct; x++) {
			if (this.list[x].countval > 0) {
				this.loading++;
				this.list[x].image.load();
			}
		}
		this.loadcycle=false;
		if (this.list[x].countval > 0) {
			this.loading++;
			this.list[x].image.load();
		}
	},

	loaded: function() {
		this.loading --;
		if (this.loading == 0 && !this.loadcycle) {
			//console.log('loaded images');
			this.app.fititems();
		}
	}
}

function vitem(buttons, name, image, iconvoff, originx, originy, max, packy, minroom, cbm) {
	this.buttons = buttons;
	this.name = name;
	if (typeof max == 'undefined') {
		max = 10;
	}
	if (typeof packy == 'undefined') {
		this.packy = false;
	} else {
		this.packy = packy;
	}
	this.minroom = minroom;
	this.max = max;
	this.image = new vimage(this, image, iconvoff, originx, originy);
	this.div = false;
	this.cbm = cbm;
	this.countval=0;
}



vitem.prototype = {
	init:function(x, y) {
		var obj=this;
		if (this.div) {
			return;
		}

		this.div = $('<div class="button"></div>')
			.append(this.count=$('<div class="button__count is-hidden"></div>'))
			.append($('<div class="button__image" />'))
			.append($('<div class="button__label">' + this.name + '</div>'))
			.append(this.lessbtn = $('<a href="#" class="button__control button__control--less less disabled"></a>')
				.on({
					click:function() {
						obj.less();
						obj.updateTotal();
						return false;
					}
				})
			)
			.append(this.morebtn = $('<a href="#" class="button__control button__control--more more"></a>')
				.on({
					click:function() {
						obj.more();
						obj.updateTotal();
						return false;
					}
				})
			)
			.on({
				mouseenter:function() {
					$('a', this).addClass('enter');
				},
				mouseleave:function() {
					$('a', this).removeClass('enter');
				}
			});

		var sectionElement = document.querySelector('[data-estimator-assets]');
		var assetsUrl = sectionElement.dataset.estimatorAssets;

    var _url = assetsUrl.split('/assets/')[0];
        
		this.div.find('.button__image').css({
			backgroundImage: 'url('+ _url +'/assets/__v__'+this.image.image+'.png)'
		});

		this.div.find('.button__control').wrapAll('<div class="button__controls" />');
		this.div.appendTo(this.buttons.div)
	},

	updateTotal: function() {
		// Updates the total text
		$('.sk_space-estimator__total').text(this.buttons.countval);
	},

	less: function() {
		if(this.countval == 0) {
			return;
		}
		this.buttons.count(-1);
		this.countval --;
		this.morebtn.removeClass('disabled');

		if (this.countval == 0) {
			this.lessbtn.addClass('disabled');
			this.count.addClass('is-hidden');
			$('.sk_space-estimator').attr('data-has-items', false);
		}


		this.count.html(this.countval == 0?'':this.countval);
	},

	more: function() {

		if(this.countval == this.max) {
			return;
		}

		$('.sk_space-estimator').attr('data-has-items', true);
		$('.sk_space-estimator__result-disclaimer').removeClass('is-visible');
		this.count.removeClass('is-hidden');

		this.countval ++;
		this.buttons.count(1);
		this.lessbtn.removeClass('disabled');

		if (this.countval == this.max) {
			this.morebtn.addClass('disabled');
		}

		this.count.html(this.countval);
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
				'event': 'space_estimator_tool',
				data: {
					'toolStep': 'add_items_to_space'
				}
		});
	}
}

function vimage(item, image, iconvoff, originx, originy) {
	this.item = item;
	this.image = image;
	this.iconvoff = iconvoff;
	this.originx = originx;
	this.originy = originy;
	this.src=false;
	this.loading = false;
}

vimage.prototype={
	init: function() {
		if(this.src) {
			return true;
		}
		return false;
	},

	load: function() {
		var obj=this;

		if (this.src) {
			setTimeout(function() {
				obj.item.buttons.loaded();
			}, 300);
			return;
		}

		if (this.loading) { return; }

		this.loading = true;

		var img=[];

		this.src = new Image();
		img.push(this.src);

		if (typeof G_vmlCanvasManager!='undefined') {
			this.ie=new Image();
			img.push(this.ie)
			obj.item.buttons.loading++;
		}

		$(img).each(function() {
			$(this).on({
				load:function() {
					obj.w = obj.originx;
					obj.d = obj.src.width - obj.originx;
					obj.item.buttons.loaded();
				},
				error:function() {
					obj.src = false;
					obj.loading=false;
					setTimeout(function() {
						obj.load();
					}, 3000);
				}
			});
		});

    var sectionElement = document.querySelector('[data-estimator-assets]');
		var assetsUrl = sectionElement.dataset.estimatorAssets;
		var _url = assetsUrl.split('/assets/')[0];

		this.src.src = _url+'/assets/__v__'+'_'+this.image+'.png';

		if (typeof G_vmlCanvasManager!='undefined') {
			this.ie.src = _url+'/assets/__v__'+'_'+this.image+'-.png';
		}
	}
}

function viroom(app) {
	this.app = app;
	this.rctx = false;
	this.div = $('div.room').hide();
}

viroom.prototype={
	init: function() {
		if(this.rctx) {
			return;
		}
		var obj=this;
		this.width=588;
		this.height=440;
		$('canvas', this.div).each(function() {
			this.width=obj.width;
			this.height=obj.height;
		});
		this.rctx = $('canvas#room').get(0).getContext('2d');
		this.octx = $('canvas#overlay').get(0).getContext('2d');
	},
	select: function(v) {
		this.ox=v[0];
		this.oy=v[1]+v[2];
		this.sy=v[2];

		this.v = v;
	},
	show: function() {
		this.div.show();
		this.drawroom();
	},
	hide: function() {
		this.init();
		this.div.hide();
	},
	clear: function() {
		this.init();
		this.rctx.clearRect(0,0,this.width,this.height);
		this.octx.clearRect(0,0,this.width,this.height);
		this.div.show();
	},
	drawroom: function() {
		// Floor

		this.rctx.fillStyle='#004986';

		this.rctx.beginPath();
		this.rctx.moveTo(this.v[0], this.v[1]+this.v[2]);
		this.rctx.lineTo(this.v[5], this.v[1]+this.v[6]);
		this.rctx.lineTo(this.v[7], this.v[8]);
		this.rctx.lineTo(this.v[3], this.v[1]+this.v[4]);
		this.rctx.closePath();
		this.rctx.fill();

		// Left Wall

		this.rctx.fillStyle='#d6d6d6';

		this.rctx.beginPath();
		this.rctx.moveTo(this.v[0], this.v[1]);
		this.rctx.lineTo(this.v[0], this.v[1]+this.v[2]);
		this.rctx.lineTo(this.v[3], this.v[1]+this.v[4]);
		this.rctx.lineTo(this.v[3], this.v[1]+this.v[4]-this.v[2]);
		this.rctx.closePath();
		this.rctx.fill();

		// Right Wall

		this.rctx.fillStyle='#a9a9a9';

		this.rctx.beginPath();
		this.rctx.moveTo(this.v[0], this.v[1]);
		this.rctx.lineTo(this.v[0], this.v[1]+this.v[2]);
		this.rctx.lineTo(this.v[5], this.v[1]+this.v[6]);
		this.rctx.lineTo(this.v[5], this.v[1]+this.v[6]-this.v[2]);
		this.rctx.closePath();
		this.rctx.fill();

		// Ceiling

		this.octx.fillStyle='rgba(255,255,255,0.2)';

		this.octx.beginPath();
		this.octx.moveTo(this.v[0], this.v[1]);
		this.octx.lineTo(this.v[5], this.v[1]+this.v[6]-this.v[2]);
		this.octx.lineTo(this.v[7], this.v[8]-this.v[2]);
		this.octx.lineTo(this.v[3], this.v[1]+this.v[4]-this.v[2]);
		this.octx.closePath();
		this.octx.fill();

		// Front Wall

		this.octx.fillStyle='rgba(255,255,255,0.29)';

		this.octx.beginPath();
		this.octx.moveTo(this.v[3], this.v[1]+this.v[4]-this.v[2]);
		this.octx.lineTo(this.v[7], this.v[8]-this.v[2]);
		this.octx.lineTo(this.v[7], this.v[8]);
		this.octx.lineTo(this.v[3], this.v[1]+this.v[4]);
		this.octx.closePath();
		this.octx.fill();
	}
}
